import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { T } from 'services/lang/LanguageService';
import { MdmTableName, TableColumn } from '../utils/types';
import useUserTableDetails from '../hooks/useUserTableDetails';
import useProjectContext from '../hooks/useProjectContext';

type TableColumnSelectionProps = {
  customColumns: string[];
  tableName: MdmTableName;
  setCustomColumns: Dispatch<SetStateAction<string[]>>;
  mapCol: TableColumn<any>[];
  handleColumnSave: () => void;
  loading: boolean;
};

const TableColumnSelection: React.FC<TableColumnSelectionProps> = ({
  customColumns,
  tableName,
  setCustomColumns,
  handleColumnSave,
  mapCol,
  loading,
}) => {
  const [changed, setChanged] = useState(false);
  const { userSettings } = useProjectContext();
  const tableDetails = useUserTableDetails(userSettings, tableName);

  useEffect(() => {
    const columns = tableDetails?.columnOrders || [];
    if (
      columns.length === customColumns.length &&
      customColumns.every((col, ind) => col === columns[ind]?.name)
    ) {
      setChanged(false);
    } else {
      setChanged(true);
    }
  }, [customColumns, tableDetails?.columnOrders])

  return (
    <div className="p-inputgroup w-max">
      <MultiSelect
        value={customColumns}
        options={mapCol}
        optionValue="columnKey"
        optionLabel="header"
        onChange={e => setCustomColumns(e.value)}
        maxSelectedLabels={0}
        filter
        resetFilterOnHide
        showSelectAll={false}
        placeholder={T("word.columns")}
        selectedItemsLabel={T("word.columns")}
      />
      <Button
        icon="pi pi-save"
        className={`p-inputgroup-addon transition-all transition-duration-400 p-button-${changed || loading ? "warning" : "success"}`}
        title={T("action.save-table-columns")}
        onClick={handleColumnSave}
        loading={loading}
      />
    </div>
  );
};

export default TableColumnSelection